// extracted by mini-css-extract-plugin
export default {"rating":"DD-z","numberOfStars":"ED-z","count":"FD-z","barGraphSpacing":"GD-z","barGraph":"HD-z"};